import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { api } from '../../lib/supabase';
import { useApi } from '../../lib/use-api';
import { ScanLine, ArrowLeft, Loader2 } from 'lucide-react';

export default function ScannerActivate() {
  const nav = useNavigate();
  const { data: events, loading } = useApi(api.getEvents);
  const medalEvents = (events || []).filter((e) => e.medalEnabled);

  const [eventId, setEventId] = useState('');
  const [name, setName] = useState('');
  const [code, setCode] = useState('');

  function handleStart() {
    sessionStorage.setItem('rivl:scanner:eventId', eventId);
    sessionStorage.setItem('rivl:scanner:name', name);
    nav('/scanner');
  }

  return (
    <div className="px-4 pt-4 pb-6 space-y-5" data-testid="scanner-activate">
      <button onClick={() => nav(-1)} className="flex items-center gap-2 text-sm text-muted-foreground" data-testid="scanner-back">
        <ArrowLeft className="h-4 w-4" /> Back
      </button>

      <div>
        <p className="rivl-label">Scanner</p>
        <h1 className="font-display text-3xl font-bold tracking-tight mt-1">Activate scanner</h1>
        <p className="text-sm text-muted-foreground mt-2">Validate medal QR codes at the finish line.</p>
      </div>

      <div className="rivl-card p-4 space-y-4">
        <div className="space-y-2">
          <Label htmlFor="event">Event</Label>
          {loading ? (
            <div className="h-11 rounded-md border border-input flex items-center px-3 text-sm text-muted-foreground">
              <Loader2 className="h-4 w-4 animate-spin mr-2" /> Loading events…
            </div>
          ) : medalEvents.length === 0 ? (
            <p className="text-xs text-muted-foreground">No medal-enabled events available.</p>
          ) : (
            <select
              id="event"
              value={eventId || medalEvents[0].id}
              onChange={(e) => setEventId(e.target.value)}
              data-testid="scanner-event-select"
              className="w-full h-11 rounded-md border border-input bg-background px-3 text-sm"
            >
              {medalEvents.map((e) => (
                <option key={e.id} value={e.id}>{e.name}</option>
              ))}
            </select>
          )}
        </div>
        <div className="space-y-2">
          <Label htmlFor="name">Volunteer name <span className="text-muted-foreground font-normal">(optional)</span></Label>
          <Input id="name" data-testid="scanner-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Jane Volunteer" className="h-11" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="code">Activation code</Label>
          <Input id="code" data-testid="scanner-code" value={code} onChange={(e) => setCode(e.target.value)} placeholder="6-digit code" inputMode="numeric" className="h-11 font-mono tracking-widest" />
        </div>
      </div>

      <Button
        onClick={handleStart}
        disabled={code.length < 4 || medalEvents.length === 0}
        className="w-full h-12 rounded-md"
        data-testid="scanner-start-btn"
      >
        <ScanLine className="h-4 w-4 mr-2" /> Activate & start scanning
      </Button>
    </div>
  );
}
